<script>
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfTablolarDetayParametre from "./StrPerfTablolarDetayParametre/IndexModal.vue";
import StrPerfTablolarDetay from "@/models/StrPerfTablolarDetay";

export default {
  mixins: [Api, Sabit, StrPerfTablolarDetay],
  props: ["TanimId", "Guncelle","DonemId"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TableData: [],
      DataUpdateAlt: null,
      Gosterge: null,
       siralama:"&Asc=SiraNo",
    };
  },
  component: {
    StrPerfTablolarDetayParametre,
  },

  watch: {
    Guncelle() {
      this.Get();
    },
  },

  methods: {
    veri_gonder(data, islem, DonemId) {
      this.$emit("DataUpdateAlt", data);
      this.$emit("AddEditAlt", islem);
      this.$emit("TabloDonemi", DonemId);
    },

    Get() {

      let Filter = "&Tabloids=" + this.TanimId;

        if(this.siralama!=null && this.siralama!=""){
        Filter=Filter+this.siralama;
      }

      this.ActionsFilterGet({ Service: "StrPerfTablolarDetay", Page: this.Page, Filter: Filter }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
  },
  created() {
    this.Get();
  },
};
</script>
<template>
  <div>
    <table class="custom-table">
      <thead>
        <tr>
          <th scope="col">{{ $t("StrPerfTablolarDetay.Table.SiraNo") }}
            <i style="margin-left:10px" v-if="siralama!='&Asc=SiraNo'" @click="siralama='&Asc=SiraNo', Get()" class="bx bx-sort-a-z fa-xl"></i>
            <i style="margin-left:10px" v-if="siralama=='&Asc=SiraNo'" @click="siralama='&Desc=SiraNo', Get()" class="bx bx-sort-z-a  fa-xl"></i>
            </th>
          <th scope="col">{{ $t("StrPerfTablolarDetay.Table.GostergeTipi") }}
          <i style="margin-left:10px" v-if="siralama!='&Asc=GostergeTipi'" @click="siralama='&Asc=GostergeTipi', Get()" class="bx bx-sort-a-z fa-xl"></i>
            <i style="margin-left:10px" v-if="siralama=='&Asc=GostergeTipi'" @click="siralama='&Desc=GostergeTipi', Get()" class="bx bx-sort-z-a  fa-xl"></i>
            </th>
          <th scope="col">{{ $t("StrPerfTablolarDetay.Table.Gostergesi") }}
          <i style="margin-left:10px" v-if="siralama!='&Asc=Gostergesi'" @click="siralama='&Asc=Gostergesi', Get()" class="bx bx-sort-a-z fa-xl"></i>
            <i style="margin-left:10px" v-if="siralama=='&Asc=Gostergesi'" @click="siralama='&Desc=Gostergesi', Get()" class="bx bx-sort-z-a  fa-xl"></i>
            </th>
          <th scope="col">{{ $t("StrPerfTablolarDetay.Table.Aciklama") }}
          <i style="margin-left:10px" v-if="siralama!='&Asc=Aciklama'" @click="siralama='&Asc=Aciklama', Get()" class="bx bx-sort-a-z fa-xl"></i>
            <i style="margin-left:10px" v-if="siralama=='&Asc=Aciklama'" @click="siralama='&Desc=Aciklama', Get()" class="bx bx-sort-z-a  fa-xl"></i>
            </th>
          <th scope="col">{{ $t("StrPerfTablolarDetay.Table.Formul") }}</th>
          <th scope="col">{{ $t("StrPerfTablolarDetay.Table.DetayVar") }}</th>
          <th scope="col">{{ $t("StrPerfTablolarDetay.Table.KanitGerekli") }}</th>
          <th scope="col">{{ $t("StrPerfTablolarDetay.Table.DetaydanHesaplamasin") }}</th>
          <th scope="col">{{ $t("StrPerfTablolarDetay.Table.HedefDonemlerindeKapali") }}</th>
          <th scope="col">{{ $t("StrPerfTablolarDetay.Table.Aktif") }}</th>
          <th scope="col">{{ $t("StrPerfTablolarDetay.Table.BaskaBirimlerGorsun") }}</th>
          <th scope="col">{{ $t("StrPerfTablolarDetay.Table.OlcumHesaplamaTuru") }}</th>
          <th style="width: 85px; text-align: center; vertical-align: middle;">{{ $t("StrPerfTablolarDetay.Table.Islem") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="HedefKartlariDetay in TableData"  :class="{ 'inactive-row': !HedefKartlariDetay.Aktif }" :key="HedefKartlariDetay.Id">

          <td>{{ HedefKartlariDetay.SiraNo }}</td>
          <td>{{ HedefKartlariDetay.GostergeTipi }}</td>
          <td>{{ HedefKartlariDetay.Gostergesi }}</td>
          <td>{{ HedefKartlariDetay.Aciklama }}</td>
          <td><i v-if="HedefKartlariDetay.FormulIcerik != null && HedefKartlariDetay.FormulIcerik != ''" class="fas fas fa-check"></i></td>
          <td>
            <span v-if="HedefKartlariDetay.DetayVar">Var</span>
            <span v-if="!HedefKartlariDetay.DetayVar">Yok</span>
          </td>
          <td>
            <span v-if="HedefKartlariDetay.KanitGerekli">Evet</span>
            <span v-if="!HedefKartlariDetay.KanitGerekli">Hayır</span>
          </td>
          <td>
            <span v-if="HedefKartlariDetay.DetaydanHesaplamasin">Hesaplanmaz </span>
            <span v-if="!HedefKartlariDetay.DetaydanHesaplamasin">Hesaplanır</span>
          </td>
          <td>
            <span v-if="HedefKartlariDetay.HedefDonemlerindeKapali">Kapalı </span>
            <span v-if="!HedefKartlariDetay.HedefDonemlerindeKapali">Açık</span>
          </td>
          <td>
            <i v-if="HedefKartlariDetay.Aktif" class="fas fas fa-check"></i>
            <i v-if="!HedefKartlariDetay.Aktif" class="fas fas fa-times"></i>
          </td>
          <td>
            <span v-if="HedefKartlariDetay.BaskaBirimlerGorsun">Görünür </span>
            <span v-if="!HedefKartlariDetay.BaskaBirimlerGorsun">Görünmez</span>
          </td>

          <td>{{ HedefKartlariDetay.OlcumHesaplamaTuru }}</td>

          <td style="width: 85px; text-align: center; vertical-align: middle;">

            <b-button-group>
                <b-button variant="primary" v-b-modal.StrPerfTablolarDetayParametre @click="$emit('Gosterge', HedefKartlariDetay.Id)"><i class="fas fa-money-check"></i></b-button>
                <b-button variant="success" v-b-modal.StrPerfTablolarDetay 
                @click="veri_gonder(HedefKartlariDetay, 'Edit', DonemId)">
                <i class="fas fa-pencil-alt"></i></b-button>
                <b-button variant="danger" @click="Delete('StrPerfTablolarDetay', HedefKartlariDetay.Id)"><i class="fas fa-trash-alt"></i></b-button>




            </b-button-group>
            
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style>
.custom-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}
.custom-table thead {
  background-color:  #2A3042; 
  color: white;
  font-weight: bold;
}
.custom-table th, .custom-table td {
  padding: 0.75rem;
  text-align: left;
}
.custom-table tbody tr:nth-of-type(odd) {
  background-color: #f8f9fa;
}
.inactive-row {
  background-color: rgba(255, 0, 0, 0.1) !important;
}

</style>
